import { useEffect, useState } from "react";
import { ws } from "api/webSocket";

export const useToast = () => {
  const [isToastActive, setIsToastActive] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    ws.watchException((e) => {
      setToastMessage(e.message);
      setIsToastActive(true);
    });
  }, []);

  const onDidDismiss = () => {
    setIsToastActive(false);
  };

  return { isToastActive, toastMessage, onDidDismiss };
};
